import React from 'react';
import { connect } from 'react-redux';
import PromoForm from './PromoForm';
import styles from './DetailPromo.css';

class DetailPromo extends React.Component {
  render() {
    return (
      <div className={styles['detail-wrapper']}>
        <PromoForm />
      </div>
    );
  }
}

export default connect()(DetailPromo);
